// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Email extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(100) */
  fromAddress?: string;
  /** String */
  htmlBody!: string;
  /** String(100) */
  messageId?: string;
  /** Int32 */
  retries!: number;
  /** String(60) */
  status!: string;
  /** DateTimeOffset */
  statusTs!: Date;
  /** String(200) */
  subject!: string;
  /** String */
  textBody!: string;
  /** String(500) */
  toAddress!: string;
}

